/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type signUpCta_viewer$ref: FragmentReference;
export type signUpCta_viewer = {|
  +home_page: ?{|
    +sign_up_cta_images: ?$ReadOnlyArray<?string>,
  |},
  +$refType: signUpCta_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "signUpCta_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "home_page",
      "storageKey": null,
      "args": null,
      "concreteType": "HomePageContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sign_up_cta_images",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node/*: any*/).hash = 'c4cf077f99a4b273b6b3393125599734';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/signUpCta_viewer.graphql.js